import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { fetchMegasigByIdApi } from "../../apis/megasig.api";
import MegasigInfoUi from "./MegasigInfoUi";

const MegasigInfoController = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  const fetchById = useCallback(
    (id) => {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await fetchMegasigByIdApi({ id }),
          (response) => {
            setData(response || {});
            setLoading(false);
          },
          () => {
            setData({});
            setLoading(false);
          },
        ),
      );
    },
    [dispatch],
  );

  useEffect(() => {
    if (id) fetchById(id);
  }, [id, fetchById]);

  return <MegasigInfoUi loading={loading} data={data} />;
};

export default MegasigInfoController;
